export const COLUMNS = [
  {
    headerName: "Class Opened ID",
    field: "id",
    width: 170,
  },
  {
    headerName: "Kỳ học",
    field: "semester",
    width: 170,
  },
  {
    headerName: "SL thực",
    field: "quantity",
    width: 100,
  },
  {
    headerName: "Loại lớp",
    field: "classType",
    width: 100,
  },
  {
    headerName: "Mã học phần",
    field: "moduleCode",
    width: 100,
  },
  {
    headerName: "Tên học phần",
    field: "moduleName",
    width: 100,
  },
  {
    headerName: "Thời lượng",
    field: "mass",
    width: 100,
  },
  {
    headerName: "SL MAX",
    field: "quantityMax",
    width: 100,
  },
  {
    headerName: "Lớp học",
    field: "studyClass",
    width: 100,
  },
  {
    headerName: "Trạng thái",
    field: "state",
    width: 100,
  },
  {
    headerName: "Mã lớp",
    field: "classCode",
    width: 100,
  },
  {
    headerName: "Kíp",
    field: "crew",
    width: 100,
  },
  {
    headerName: "Đợt",
    field: "openBatch",
    width: 100,
  },
  {
    headerName: "Khóa",
    field: "course",
    width: 100,
  },
  {
    headerName: "Tiết BĐ",
    field: "startPeriod",
    width: 100,
  },
  {
    headerName: "Thứ",
    field: "weekday",
    width: 100,
  },
  {
    headerName: "Phòng",
    field: "classroom",
    width: 100,
  },
  {
    headerName: "Tiết BĐ thứ hai",
    field: "secondStartPeriod",
    width: 100,
  },
  {
    headerName: "Thứ",
    field: "secondWeekday",
    width: 100,
  },
  {
    headerName: "Phòng",
    field: "secondClassroom",
    width: 100,
  },
];
